import { faShareNodes, faTableColumns } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
export const actions: IAction[] = [
  {
    context: 'savedCharts',
    id: 'Sharing',
    displayName: 'Deling',
    icon: faShareNodes,
    isVisible: selctedCount => selctedCount > 0,
  },
  {
    context: 'savedCharts',
    id: 'ColumnChooser',
    displayName: 'Kolonner',
    icon: faTableColumns,
    isVisible: () => true,
  },
];
